<template>
    <div>
        <h4>Аналітика</h4>
        <h5>Унікальних відвідувачів за поточний день ({{ da }}) / тиждень ({{ wa }}) / місяць ({{  ma}}) / рік ({{ ya }})</h5>

        <p class="mt-2">Зайняте місце на диску: </p>
        <ProgressBar :value="size_percent" class="mb-4"></ProgressBar>

        <div>
            <table>
                <tr>
                    <th>Бренд з 1С</th>
                    <th>Бренд як характеристика</th>
                    <th>Кількість SKU</th>
                    <th>Заповнено категорій</th>
                    <th>Заповнено фото</th>
                    <th>Заповнено описів</th>
                    <th>Заповнено аксесуарів</th>
                    <th>Заповнено документів</th>
                    <th>Заповнено характеристик</th>
                    <th>Заповнено Аналоги</th>
                    <th>Заповнено З цим товаром купують</th>
                </tr>


                <tr v-for="(item, i) in data" :key="`item_${i}`">
                    <td>{{ i }}</td>
                    <td>
                        <p class="m-0 p-0" v-for="(itemsCount, brandName) in item.sku_brand_сharacteristic" :key="`sku_brand_сharacteristic_${brandName}`">{{ brandName }} ({{ itemsCount }})</p>
                    </td>
                    <td>{{ item.sku }}</td>
                    <td>{{ item.group }}</td>
                    <td>{{ item.photo }}</td>
                    <td>{{ item.descriptions }}</td>
                    <td>{{ item.accessories }}</td>
                    <td>{{ item.docs }}</td>
                    <td>{{ item.characteristics }}</td>
                    <td>{{ item.analogs }}</td>
                    <td>{{ item.catalog_buy_with_products }}</td>
                </tr>

                <tr>
                    <td><b>Всього: </b></td>
                    <td><b>{{ tprod_brand_сharacteristic }}</b></td>
                    <td><b>{{ tprod }}</b></td>
                    <td><b>{{ tgroup }}</b></td>
                    <td><b>{{ totalphoto }}</b></td>
                    <td><b>{{ total_descriptions }}</b></td>
                    <td><b>{{ totalaccessories }}</b></td>
                    <td><b>{{ totaldocs }}</b></td>
                    <td><b>{{ totalcharacteristics }}</b></td>
                    <td><b>{{ totalAnalogs }}</b></td>
                    <td><b>{{ totalBuyWithProducts }}</b></td>
                </tr>

                <tr>
                    <td><b>B2B: </b></td>
                    <td><b></b></td>
                    <td><b>{{ b2bTotal }}</b></td>
                    <td></td>
                    <td><b>{{ b2bPhoto }}</b></td>
                    <td><b>{{ b2bDescriptions }}</b></td>
                    <td><b>{{ b2bAccessoriesCount }}</b></td>
                    <td><b>{{ b2bDocs }}</b></td>
                    <td><b>{{ b2bCharacteristics }}</b></td>
                    <td><b>{{ b2bAnalogCount }}</b></td>
                    <td><b>{{ b2bCatalogBuyWithProductCount }}</b></td>
                </tr>

                <tr>
                    <td><b>B2C: </b></td>
                    <td><b></b></td>
                    <td><b>{{ b2cTotal }}</b></td>
                    <td></td>
                    <td><b>{{ b2cPhoto }}</b></td>
                    <td><b>{{ b2cDescriptions }}</b></td>
                    <td><b>{{ b2cAccessoriesCount }}</b></td>
                    <td><b>{{ b2cDocs }}</b></td>
                    <td><b>{{ b2cCharacteristics }}</b></td>
                    <td><b>{{ b2cAnalogCount }}</b></td>
                    <td><b>{{ b2cCatalogBuyWithProductCount }}</b></td>
                </tr>

                <tr>
                    <td>
                        <b>Без категорій з 1С:</b>
                    </td>
                    <td></td>
                    <td colspan="9">
                        <b>{{ b2bProductsInInactiveCategories }}</b>
                    </td>
                </tr>
                <tr>
                    <td>
                        <b>Без категорій як лейба у ТМЦ:</b>
                    </td>
                    <td></td>
                    <td colspan="9">
                        <b>{{ emptyCategoriesCount }}</b>
                    </td>
                </tr>

                <tr>
                    <td colspan="11">
                        <b>Загальна вага всіх типів файлів: {{ formatBytes(size, 2) }}</b>
                    </td>
                </tr>

            </table>
        </div>
    </div>
</template>

<script>
import AppLayout from '@/Layouts/AppLayout.vue'
import FileUpload from 'primevue/fileupload';
import Toast from 'primevue/toast';
import ProgressBar from 'primevue/progressbar';
import moment from "moment";
import Input from '../Jetstream/Input.vue';
import axios from "axios";
import Button from "primevue/button";

export default {
    layout: AppLayout,
    props: {
        data: {
            type: Object,
            required: false,
        },
        tprod: {
            type: Number,
            required: false,
        },
        tgroup: {
            type: Number,
            required: false,
        },
        tprod_brand_сharacteristic: {
            type: Number,
            required: false,
        },
        aprod: {
            type: Number,
            required: false,
        },
        dprod: {
            type: Number,
            required: false,
        },
        tchar: {
            type: Number,
            required: false,
        },
        tprc: {
            type: Number,
            required: false,
        },
        da: {
            type: Number,
            required: false,
        },
        wa: {
            type: Number,
            required: false,
        },
        ma: {
            type: Number,
            required: false,
        },
        ya: {
            type: Number,
            required: false,
        },
        size: {
            type: Number,
            required: false,
        },
        size_percent: {
            type: Number,
            required: false,
        },
        totalphoto: {
            type: Number,
            required: false,
        },
        total_descriptions: {
            type: Number,
            required: false,
        },
        totaldocs: {
            type: Number,
            required: false,
        },
        totalaccessories: {
            type: Number,
            required: false,
        },
        totalcharacteristics: {
            type: Number,
            required: false,
        },
        totalAnalogs: {
            type: Number,
            required: false,
        },
        totalBuyWithProducts: {
            type: Number,
            required: false,
        },

        b2bTotal: {
            type: Number,
            required: false,
        },
        b2bPhoto: {
            type: Number,
            required: false,
        },
        b2bDescriptions: {
            type: Number,
            required: false,
        },
        b2bAccessoriesCount: {
            type: Number,
            required: false,
        },
        b2bDocs: {
            type: Number,
            required: false,
        },
        b2bCharacteristics: {
            type: Number,
            required: false,
        },
        b2bAnalogCount: {
            type: Number,
            required: false,
        },
        b2bCatalogBuyWithProductCount: {
            type: Number,
            required: false,
        },

        b2cTotal: {
            type: Number,
            required: false,
        },
        b2cPhoto: {
            type: Number,
            required: false,
        },
        b2cDescriptions: {
            type: Number,
            required: false,
        },
        b2cAccessoriesCount: {
            type: Number,
            required: false,
        },
        b2cDocs: {
            type: Number,
            required: false,
        },
        b2cCharacteristics: {
            type: Number,
            required: false,
        },
        b2cAnalogCount: {
            type: Number,
            required: false,
        },
        b2cCatalogBuyWithProductCount: {
            type: Number,
            required: false,
        },

        b2bProductsInInactiveCategories: {
            type: Number,
            required: false,
        },
        
        emptyCategoriesCount: {
            type: Number,
            required: false,
        },
    },
    data() {
        return {
            progressCatalogFiles: false,
            moment: moment,
        }
    },
    components: {
        ProgressBar,
        "p-fileupload": FileUpload,
        "p-toast": Toast,
        Input,
        Button,
    },
    methods: {
        formatBytes(bytes, decimals = 2) {
            if (!+bytes) return '0 Bytes'

            const k = 1024
            const dm = decimals < 0 ? 0 : decimals
            const sizes = ['Bytes', 'KB', 'MB', 'GB', 'TB', 'PB', 'EB', 'ZB', 'YB']

            const i = Math.floor(Math.log(bytes) / Math.log(k))

            return `${parseFloat((bytes / Math.pow(k, i)).toFixed(dm))} ${sizes[i]}`
        },
    }
};
</script>

<style scoped>
table {
  font-family: arial, sans-serif;
  border-collapse: collapse;
  width: 100%;
}

td, th {
  border: 1px solid #dddddd;
  text-align: left;
  padding: 5px;
  font-size: 14px;
}

tr:nth-child(even) {
  background-color: #dddddd;
}
</style>
